import {
  apiRequest as _apiRequest,
  getApiUrl,
} from '@thyme/libs/src/api/apiRequest'
import { Method, RequestOptions } from '@thyme/libs/src/api/types/api'
import { auth0, getAccessToken } from '@/auth'
import { useConfigStore } from '@/legacy/store/modules/config'
import { useFlagStore } from '@/store/flags/flags'
import { DEPLOY_VERSION } from '@/version'

// CONST
const ENTITY_ID_CLAIM = 'https://thymecare.com/entity-id'
const VPN_TEST_TIMEOUT_SECS = 2

/**
 *
 */
function getThymeEntityId(): string | null {
  return auth0().user.value?.[ENTITY_ID_CLAIM] ?? null
}

/**
 *
 */
async function getAuthHeaderValue(): Promise<string> {
  return `Bearer ${await getAccessToken()}`
}

/**
 * Generates a valid API URL given an endpoint and request parameters.
 * @param endpoint
 * @param params
 */
export function apiUrl<P extends object>(endpoint: string, params?: P) {
  return getApiUrl(getBaseUrl(), endpoint, params, {
    arrayFormat: 'repeat',
  })
}

/**
 *
 */
function getBaseUrl(): string {
  const configVals = useConfigStore().configVals
  if (!configVals) {
    throw new Error('Cannot generate API URL before config is loaded')
  }
  const override = useFlagStore().apiUrlOverride
  if (override?.url) {
    return override.url
  }

  return configVals.apiUrl
}

/**
 *
 * @param method
 * @param endpoint
 * @param options
 */
export async function apiRequest<R>(
  method: Method,
  endpoint: string,
  options: RequestOptions = {}
): Promise<R> {
  let headers: { [key: string]: string } = {
    Authorization: await getAuthHeaderValue(),
  }

  const userId = getThymeEntityId()

  if (userId) {
    headers['Thymebox-User-Id'] = userId
  }

  headers['X-Thymebox-Version'] = DEPLOY_VERSION

  headers = {
    ...headers,
    ...options.headers,
  }

  return await _apiRequest(
    method,
    endpoint,
    {
      ...options,
      headers,
      paramSerializationOptions: {
        arrayFormat: 'repeat',
        ...options.paramSerializationOptions,
      },
    },
    getBaseUrl()
  )
}

export const Timeout = (time: number) => {
  const controller = new AbortController()
  const ms = 1000
  const timeout_ms = ms * time
  setTimeout(() => controller.abort(), timeout_ms)
  return controller
}

/**
/* Calls the /healthz endpoint to test VPN connectivity. Returns true if successful, false otherwise.
/*
/* This does not require authentication..
/*
 */
export async function testVpn() {
  try {
    await fetch(apiUrl('/healthz'), {
      signal: Timeout(VPN_TEST_TIMEOUT_SECS).signal,
    })
    console.log('Successfully hit /healthz endpoint')
    return true
  } catch (err) {
    console.log('Could not hit /healthz endpoint', err)
    return false
  }
}
